module.exports = "pegasus/assets/blocks/column-18-basic.png";